import { useState } from 'react';
import { brand } from '../theme/tokens';
import { useLanguage } from './language-context';

// The add-to-home-screen bar (design DC:3788-3794, `a2hsShow` DC:4813; CB-17
// website-only `add-to-home-bar.tsx`). A dark rounded bar floating just above the tab
// bar on the mobile home page, inviting the visitor to pin the site. Dismissing it is
// remembered in this browser (a per-viewer convenience, so localStorage is the right
// store — it is not account state), and every storage access is guarded so a private
// window or blocked storage just shows the bar again rather than breaking the page.
//
// Mobile-only visibility is CSS (`.a2hs` is display:none from 768 px); the home-only
// rule is the caller's (AppLayout renders it on "/").

export const A2HS_DISMISSED_KEY = 'bd.a2hs.dismissed';

function readDismissed(): boolean {
  try {
    return localStorage.getItem(A2HS_DISMISSED_KEY) === '1';
  } catch {
    return false;
  }
}

export function AddToHomeBar() {
  const { t } = useLanguage();
  const [dismissed, setDismissed] = useState(readDismissed);

  if (dismissed) return null;

  function dismiss() {
    setDismissed(true);
    try {
      localStorage.setItem(A2HS_DISMISSED_KEY, '1');
    } catch {
      /* storage unavailable — dismissed for this page view only */
    }
  }

  return (
    <aside className="a2hs" aria-label={t('a2hs.label')}>
      <span className="a2hs__tile" aria-hidden="true">
        {brand.name.charAt(0)}
      </span>
      <span className="a2hs__text">{t('a2hs.text')}</span>
      <button type="button" className="a2hs__close" aria-label={t('a2hs.dismiss')} onClick={dismiss}>
        <span aria-hidden="true">✕</span>
      </button>
    </aside>
  );
}
